"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSpinner = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _spinner = require("../../spinner");
var _getButtonTextColor = require("../styled/getButtonTextColor");
const LoadingSpinner = _ref => {
  let {
    appearance,
    themeMode
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledLoadingSpinner, null, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
    size: "medium",
    color: (0, _getButtonTextColor.getButtonTextColor)({
      appearance,
      themeMode,
      state: {
        isActive: false,
        isDisabled: false,
        isFocus: false,
        isHover: false
      }
    })
  }));
};
exports.LoadingSpinner = LoadingSpinner;
const StyledLoadingSpinner = (0, _styled.default)("div")`
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;
//# sourceMappingURL=LoadingSpinner.js.map